import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { deprecationPropWarning } from "../../utils/deprecation";
export const Box = props => {
    const { backgroundColor, children, className, height, m, margin, marginBlockEnd, marginBlockStart, marginInlineEnd, marginInlineStart, maxHeight, maxWidth, mb, minHeight, minWidth, ml, mr, mt, padding, paddingBlockEnd, paddingBlockStart, paddingInlineEnd, paddingInlineStart, style, width, ...rest } = props;
    const stringNumber = (v) => typeof v === "number" ? `${v}px` : v;
    deprecationPropWarning("Box", props, [
        "margin",
        "marginBlockEnd",
        "marginBlockStart",
        "marginInlineEnd",
        "marginInlineStart",
        "padding",
        "paddingBlockEnd",
        "paddingBlockStart",
        "paddingInlineEnd",
        "paddingInlineStart",
        "backgroundColor",
    ]);
    return (_jsx("div", { className: classNames(`eds-box`, className), style: {
            height: stringNumber(height),
            width: stringNumber(width),
            maxHeight: stringNumber(maxHeight),
            maxWidth: stringNumber(maxWidth),
            minHeight: stringNumber(minHeight),
            minWidth: stringNumber(minWidth),
            margin: stringNumber(m !== null && m !== void 0 ? m : margin),
            marginTop: stringNumber(mt !== null && mt !== void 0 ? mt : marginBlockStart),
            marginBottom: stringNumber(mb !== null && mb !== void 0 ? mb : marginBlockEnd),
            marginLeft: stringNumber(ml !== null && ml !== void 0 ? ml : marginInlineStart),
            marginRight: stringNumber(mr !== null && mr !== void 0 ? mr : marginInlineEnd),
            padding: stringNumber(padding),
            paddingBlockStart: stringNumber(paddingBlockStart),
            paddingBlockEnd: stringNumber(paddingBlockEnd),
            paddingInlineStart: stringNumber(paddingInlineStart),
            paddingInlineEnd: stringNumber(paddingInlineEnd),
            backgroundColor: stringNumber(backgroundColor),
            ...style,
        }, ...rest, children: children }));
};
